import { render, staticRenderFns } from "./ArchiveSynthesizer.vue?vue&type=template&id=c6e49594&scoped=true"
import script from "./ArchiveSynthesizer.vue?vue&type=script&lang=js"
export * from "./ArchiveSynthesizer.vue?vue&type=script&lang=js"
import style0 from "./ArchiveSynthesizer.vue?vue&type=style&index=0&id=c6e49594&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e49594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e49594')) {
      api.createRecord('c6e49594', component.options)
    } else {
      api.reload('c6e49594', component.options)
    }
    module.hot.accept("./ArchiveSynthesizer.vue?vue&type=template&id=c6e49594&scoped=true", function () {
      api.rerender('c6e49594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/ArchiveSynthesizer.vue"
export default component.exports